<template lang="pug">
  div(class="wheel")
    img(class="wheel-shadow" src="@/assets/images/wheel-shadow.png")
    div(class="wheel-image" :style="background")
</template>

<script>
export default {
  name: 'wheel',
  props: ['selected', 'current', 'animating'],
  data () {
    return {
      sprite: '/static/wheel-sprite.png'
    }
  },
  computed: {
    background () {
      return {
        backgroundImage: 'url(' + this.sprite + ')',
        backgroundPosition: this.pos.x + 'px ' + this.pos.y + 'px'
      }
    },
    pos () {
      return {
        x: this.animating ? 362 : 0,
        y: 362 * -(this.current - 1)
      }
    }
  }
}
</script>

<style lang="stylus">
.wheel
  position: fixed
  left: 5em
  height: 40em
  width: 40em
  bottom: 5em
  z-index: 5
  display: flex
  align-items: center;
  justify-content: center;
  transition: transform 200ms ease
  @media (min-height: 1400px)
    transform: scale(1.2);
  @media (max-height: 1200px)
    transform: scale(0.9) translateY(6em);
  @media (max-height: 1000px)
    transform: scale(0.8) translateY(8em);
  @media (max-height: 900px)
    transform: scale(0.7) translateY(9em);
  @media (max-height: 800px)
    transform: scale(0.7) translateY(17em);
  &-image
    height: 362px
    width: 362px
    flex: 0 0 362px
    z-index: 2
  &-shadow
    position: absolute;
    bottom: calc(20em - 190px)

.animating
  & .wheel
    &-image
      animation: spin 100ms infinite

@keyframes spin
  0%
    transform: rotate(0deg)
  100%
    transform: rotate(360deg)
</style>



// WEBPACK FOOTER //
// src/components/wheel.vue